module.exports = __webpack_public_path__ + "img/logo.cf87c64c.png";